import { Protocol } from '../../models/Entities/Protocols/Protocol';

export interface ProtocolFinancialMetrics {
  protocolId: number | string;
  name: string;
  revenue: number;
  cost: number;
  profit: number;
  profitability: number; // profit / revenue * 100
  gainPercent: number;   // profit / cost * 100 (ROI)
}

// Deterministic hash-based factor to keep stable synthetic values across charts
const hashFactor = (key: string | number) => {
  const s = key.toString();
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0;
  return 0.9 + (h % 1000) / 1000 * 0.25; // [0.9,1.15]
};

export function computeProtocolFinancialMetrics(protocols: Protocol[]): ProtocolFinancialMetrics[] {
  return (protocols || []).map((p, idx) => {
    const base = (p.patientsObjective || 0) * 1000;
    const factor = hashFactor(p.protocolNumber || p.id) * (1 + Math.sin(idx) * 0.05);
    const revenue = Math.round(base * factor);
    const costRatio = 0.55 + ((factor - 0.9) / 0.25) * 0.15; // ~[0.55,0.70]
    const cost = Math.round(revenue * costRatio);
    const profit = revenue - cost;
    const profitability = revenue > 0 ? (profit / revenue) * 100 : 0;
    const gainPercent = cost > 0 ? (profit / cost) * 100 : 0;
    return {
      protocolId: p.id,
      name: p.protocolNumber || p.title || `Prot ${p.id}`,
      revenue,
      cost,
      profit,
      profitability,
      gainPercent
    };
  });
}

export function indexProtocolMetrics(metrics: ProtocolFinancialMetrics[]): Record<string | number, ProtocolFinancialMetrics> {
  const map: Record<string | number, ProtocolFinancialMetrics> = {};
  metrics.forEach(m => { map[m.protocolId] = m; });
  return map;
}
